import { FunctionComponent, ReactNode } from 'react';

type FormHeaderProperties = {
    description: string | ReactNode;
    title: string | ReactNode;
};

export const FormHeader: FunctionComponent<FormHeaderProperties> = ({ title, description }) => {
    return (
        <div className="sm:flex sm:items-center">
            <div className="sm:flex-auto">
                <h1 className="text-base font-semibold leading-7 text-gray-900">{title}</h1>
                <p className="mt-1 text-sm leading-6 text-gray-700">{description}</p>
            </div>
        </div>
    );
};
